import { Action, ActionType } from 'typesafe-actions';
import { ofType } from 'redux-observable';
import { Observable, of, OperatorFunction } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { toReduxError } from '@universal/errors';
import { apiClient, ApiType, ApiPaths } from '@shared/apiClient';
import { fromApiRequest } from '@shared/apiClient/fromApiRequest';
import { InvoiceType } from '@appTypes/InvoiceType';
import { Actions, invoiceActions } from '@redux/modules/myInvoices';
import { TypedEpic } from './types';

export const getMyInvoicesEpic: TypedEpic = (action$: Observable<Action<any>>, state$) =>
  action$.pipe(
    ofType(Actions.GET_MY_INVOICES),
    withLatestFrom(state$) as unknown as OperatorFunction<
      Action<any>,
      ActionType<typeof invoiceActions.getMyInvoices.request>[]
    >,
    switchMap(() =>
      fromApiRequest((signal) =>
        apiClient.get<InvoiceType[]>(ApiType.apimMembershipApi, {
          signal,
          url: ApiPaths[ApiType.apimMembershipApi].invoices,
        }),
      ).pipe(
        map((response) => invoiceActions.getMyInvoices.success(response.data)),
        catchError((err) =>
          of(
            invoiceActions.getMyInvoices.failure(
              toReduxError(
                err,
                'Oops, vi har problemer med motoren... Kunne ikke hente fakturaer! Ta kontakt med kundesenteret hvis problemet fortsetter!',
              ),
            ),
          ),
        ),
      ),
    ),
  );

export const epics: TypedEpic[] = [getMyInvoicesEpic];
